import { connect } from 'react-redux'
import * as selector from '../../../customer/state/detail/selector'
import AppointmentList from '../list/AppointmentList'


const mapStateToProps = (state, props) => {
    const { appointmentList } = selector.selectCustomer(state)
    return {
        appointmentList,
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentList)



// WEBPACK FOOTER //
// ./src/modules/appointment/component/task-widget/AppointmentListWidgetContainer.js